import { Component } from '@angular/core';
import { EvtResponse } from '@entities/evt-alert/evt-alert.adapter';
import { EvtAlertStoreEntity } from '@entities/evt-alert/evt-alert.reducer';
import { EvtAlertService } from '@entities/evt-alert/evt-alert.service';
import { ProductUtils } from '@shared/utils/product.util';
import { Observable } from 'rxjs';

interface EvtAlertViewModel {
  name: string; // of product
  quoteId: string;
  response: EvtResponse;
}

@Component({
    selector: 'nwx-fraud-alert',
    templateUrl: './fraud-alert.component.html',
    styleUrl: './fraud-alert.component.scss',
    standalone: false
})
export class FraudAlertComponent {
  evtAlerts$: Observable<EvtAlertStoreEntity[]>;

  constructor(private evtAlertService: EvtAlertService) {
    this.evtAlerts$ = this.evtAlertService.getAllEvtAlerts();
  }

  sanitizeAlerts(input: EvtAlertStoreEntity[]): EvtAlertViewModel[] {
    return input
      .filter((p) => p.response?.length)
      .map((p) => ({
        name: ProductUtils.getShortNameForProduct(p.productType),
        quoteId: p.quoteId,
        response: p.response,
      }) as EvtAlertViewModel);
  }
}
